// datetime-local inputs want 'YYYY-MM-DDTHH:mm' in the viewer's local time.
export function toDateTimeLocalValue(date: Date): string {
  const pad = (value: number): string => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function nowForDateTimeLocal(): string {
  return toDateTimeLocalValue(new Date());
}
